import { Products, useDeleteProductMutation } from 'prove-common'
import { ReferenceTable } from '../reference-table/ReferenceTable'

type ProductsTableProps = {
  products: Products
}

export const ProductsTable = ({ products }: ProductsTableProps) => {
  const deleteProduct = useDeleteProductMutation()

  return (
    <ReferenceTable
      rows={products}
      title='Produkter'
      emptyTitle='Ingen produkter'
      columns={[
        { key: 'name', label: 'Navn', value: (product) => product.name },
        { key: 'code', label: 'Kode', value: (product) => product.code },
        { key: 'id', label: 'ID', value: (product) => product.id, copy: true }
      ]}
      name={(product) => product.name}
      onDelete={(id) => deleteProduct.mutateAsync(id)}
    />
  )
}
